import React, {Component} from 'react'

import SettingsGroup from '../../../struct/SettingsGroup'
import Field from '../../../struct/Field'
import InputText from 'lib/struct/form/InputText'
import Select from 'lib/struct/form/Select'


import styles from './ShopSettings.less'
import Link from "bsui/Link/Link";
import Iconui from 'lib/struct/iconui/Iconui';


const types = [{
    label: 'DBS',
    value: 'DBS',
}, {
    label: 'FBS',
    value: 'FBS',
}, {
    label: 'FBS Экспресс',
    value: 'FBSX',
}]

export default class CustomSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            type: this.props.campaign.type,
        }
    }

    changeFieldValue = (fieldName, value) => {
        this.setState({[fieldName]: value})
        this.props.campaign[fieldName] = value
    }

    handleDeleteCampaign = () => {
        this.props.onCampaignDelete(campaign)
    }

    render() {
        const {campaign, onCampaignDelete} = this.props


        return (
            <SettingsGroup className={styles['settings-block']}>
                <Link className={styles['campaign-delete']}
                    onClick={e => onCampaignDelete(campaign.id)}
                    data-confirm-text="Удалить этот профиль вместе с настройками?">
                    <Iconui name="delete" />Удалить профиль
                </Link>
                <Field label="Название профиля">
                    <InputText
                        defaultValue={campaign.name}
                        onChange={e => campaign.name = e.target.value}
                        disabled={false}
                        readOnly={false}
                        placeholder={'Новый профиль'}
                    />
                </Field>
                <Field label="Модель работы с маркетплейсом" fieldClass={styles['select-field-box']}>
                    <Select
                        options={types}
                        value={this.state.type}
                        onChange={e => this.changeFieldValue('type', e.target.value)}
                    />
                </Field>
            </SettingsGroup>
        )
    }
}